import Vue from 'vue'
import vuex from 'vuex'
import { API_BASE_URL_SLASH } from '../config'

const USER_KEY = 'dbtool_user'

function loadUser() {
    try {
        const s = localStorage.getItem(USER_KEY)
        return s ? JSON.parse(s) : null
    } catch (e) {
        return null
    }
}

const state = {
    txtdata: "",
    basicurl: API_BASE_URL_SLASH,
    // 用户登录状态：null 未登录；{ token, username, coins } 已登录
    user: loadUser(),
    // 登录/注册弹窗（由 TopBar 显示，可从 Azuretts 下载提示打开）
    showLoginDialog: false,
    loginDialogTab: 'login',
    /** login：扫码/手机登录；wxRegister：新用户微信注册向导（合并原「注册」Tab） */
    loginAuthPanel: 'login',
    // 从下载提示触发的待执行下载类型，登录成功后由 Azuretts 执行
    pendingDownloadAction: null,
    // TopBar 点击「购买金币」时由 Azuretts 打开支付弹窗
    openPayDialog: false,
    // TopBar「赚金币」下拉：扫码看视频验证码
    openEarnCoinDialog: false,
    coinChargeEnabled: true,
    freeModeNotice: '',
    legacyCoinFeatureEnabled: true,
    miniProgramCoinFeatureEnabled: false,
    // 任意页面点击「联系我们」时打开（由 TopBar 渲染同一弹窗）
    openContactDialog: false,
    // 暗黑模式
    darkMode: localStorage.getItem('dbtool_dark_mode') === '1',
    // 每日签到状态
    checkedInToday: false
}

const mutations = {
    Updatetxtdata(state, value) {
        state.txtdata = value
    },
    Replacetxtdata(state, formdata) {
        var reg = new RegExp(formdata.olddata, "g")
        state.txtdata = state.txtdata.replace(reg, formdata.newdata)
    },
    SetUser(state, user) {
        state.user = user
        if (user) {
            localStorage.setItem(USER_KEY, JSON.stringify(user))
        } else {
            localStorage.removeItem(USER_KEY)
        }
    },
    SetUserCoins(state, coins) {
        if (state.user) {
            state.user.coins = coins
            localStorage.setItem(USER_KEY, JSON.stringify(state.user))
        }
    },
    /** DbtoolOpenid 已有 userid 时为 true，TopBar 隐藏「关注公众号赚金币」 */
    SetUserHideFollowOfficialEarn(state, hide) {
        if (!state.user) return
        state.user = { ...state.user, hideFollowOfficialEarn: !!hide }
        localStorage.setItem(USER_KEY, JSON.stringify(state.user))
    },
    SetShowLoginDialog(state, payload) {
        if (payload.show === false) {
            state.showLoginDialog = false
            state.loginAuthPanel = 'login'
            state.loginDialogTab = 'login'
            return
        }
        state.showLoginDialog = true
        const wantWxRegister = payload.tab === 'register' || payload.panel === 'wxRegister'
        if (wantWxRegister) {
            state.loginAuthPanel = 'wxRegister'
            state.loginDialogTab = 'login'
        } else {
            state.loginAuthPanel = 'login'
            if (payload.tab) state.loginDialogTab = payload.tab
            else state.loginDialogTab = 'login'
        }
    },
    SetPendingDownloadAction(state, action) {
        state.pendingDownloadAction = action
    },
    SetOpenPayDialog(state, open) {
        state.openPayDialog = !!open
    },
    SetOpenEarnCoinDialog(state, open) {
        state.openEarnCoinDialog = !!open
    },
    SetCoinFeatureModes(state, payload) {
        const data = payload || {}
        state.coinChargeEnabled = data.coinChargeEnabled !== false
        state.freeModeNotice = data.freeModeNotice || ''
        state.legacyCoinFeatureEnabled = data.legacyCoinFeatureEnabled !== false
        state.miniProgramCoinFeatureEnabled = !!data.miniProgramCoinFeatureEnabled
    },
    SetOpenContactDialog(state, open) {
        state.openContactDialog = !!open
    },
    SetDarkMode(state, val) {
        state.darkMode = !!val
        localStorage.setItem('dbtool_dark_mode', val ? '1' : '0')
    },
    SetCheckedInToday(state, val) {
        state.checkedInToday = !!val
    }
}

Vue.use(vuex)
const store = new vuex.Store({
    state,
    mutations
})
export default store
